import '@fontsource/geist/300.css';
import '@fontsource/geist/400.css';
import '@fontsource/geist/500.css';
import '@fontsource/geist/600.css';
import '@fontsource/geist/700.css';
import '@fontsource/geist-mono/300.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/geist-mono/500.css';
import '@fontsource/geist-mono/600.css';
import '@fontsource/geist-mono/700.css';
import './styles/webflow.css';
import './styles/custom.css';
import './styles/interactions.css';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { createRouter } from './router';

const router = createRouter();
const root = document.getElementById('root')!;

// Production pages are prerendered (scripts/prerender.ts) and hydrated; `vite dev` renders from scratch.
// index.html's root holds a placeholder comment in dev; prerendered pages have real markup.
const prerendered = root.firstElementChild !== null;
if (prerendered) {
  // Render the same tree the server did. TanStack's own hydrate() sets this from state it
  // serializes into the page; the site never navigates client-side, so that state (which
  // would duplicate every page's content) isn't needed and the flag is set directly.
  router.ssr = { manifest: undefined };
}
await router.load();
const app = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
if (prerendered) hydrateRoot(root, app);
else createRoot(root).render(app);
